<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Impotents" pageTitle="Impotents" />
            <ImpotentsContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import ImpotentsContent from '../Impotents/ImpotentsContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'ImpotentsPage',
    components: {
        MainHeader,
        PageTitle,
        ImpotentsContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>